import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { StationMessages } from '../../../constants/StationConstants';
import {
  getDaysAgo,
  getMonthName,
  getMonthsAgo,
  getWeeksAgo,
  isSameDay,
} from '../../../lib/TimeUtils';

class LastUpdated extends React.Component {
  static propTypes = {
    now: PropTypes.object.isRequired,
    lastPlayed: PropTypes.object,
    dateCollected: PropTypes.object,
  };

  renderUpdatedToday = () => {
    const message = this.props.dateCollected ? (
      <FormattedMessage {...StationMessages.collectedToday} />
    ) : (
      <FormattedMessage {...StationMessages.listenedToday} />
    );
    return message;
  };

  renderUpdatedDaysAgo = daysAgo => {
    const message = this.props.dateCollected ? (
      <FormattedMessage {...StationMessages.collectedDaysAgo} values={{ day: daysAgo }} />
    ) : (
      <FormattedMessage {...StationMessages.listenedDaysAgo} values={{ day: daysAgo }} />
    );
    return message;
  };

  renderWeeksAgo = weeksAgo => {
    const message = this.props.dateCollected ? (
      <FormattedMessage {...StationMessages.collectedWeeksAgo} values={{ week: weeksAgo }} />
    ) : (
      <FormattedMessage {...StationMessages.listenedWeeksAgo} values={{ week: weeksAgo }} />
    );
    return message;
  };

  renderMonthsAgo = monthsAgo => {
    const message = this.props.dateCollected ? (
      <FormattedMessage {...StationMessages.collectedMonthsAgo} values={{ month: monthsAgo }} />
    ) : (
      <FormattedMessage {...StationMessages.listenedMonthsAgo} values={{ month: monthsAgo }} />
    );
    return message;
  };

  renderInMonthYear = lastUpdated => {
    const message = this.props.dateCollected ? (
      <FormattedMessage
        {...StationMessages.collectedInMonthYear}
        values={{
          month: getMonthName(lastUpdated.getMonth()),
          year: lastUpdated.getFullYear(),
        }}
      />
    ) : (
      <FormattedMessage
        {...StationMessages.listenedInMonthYear}
        values={{
          month: getMonthName(lastUpdated.getMonth()),
          year: lastUpdated.getFullYear(),
        }}
      />
    );
    return message;
  };

  renderNeverUpdated = () => {
    const message = this.props.dateCollected ? (
      <FormattedMessage {...StationMessages.neverCollected} />
    ) : (
      <FormattedMessage {...StationMessages.neverListened} />
    );
    return message;
  };

  render() {
    const { now, lastPlayed, dateCollected } = this.props;

    if (!lastPlayed && !dateCollected) {
      return this.renderNeverUpdated();
    }

    const nowTimestamp = now.getTime();
    const lastUpdatedTimestamp = lastPlayed ? lastPlayed.getTime() : dateCollected.getTime();
    const setFilterData = lastPlayed || dateCollected;
    if (isSameDay(now, setFilterData)) {
      return this.renderUpdatedToday();
    }

    const weeksAgo = getWeeksAgo(nowTimestamp, lastUpdatedTimestamp);
    if (weeksAgo < 1) {
      let daysAgo = getDaysAgo(nowTimestamp, lastUpdatedTimestamp);

      // last updated time happened yesterday, but less than 24hrs ago.
      if (daysAgo === 0) {
        daysAgo = 1;
      }
      return this.renderUpdatedDaysAgo(daysAgo);
    }

    const monthsAgo = getMonthsAgo(nowTimestamp, lastUpdatedTimestamp);
    if (weeksAgo < 4) {
      return this.renderWeeksAgo(weeksAgo);
    }

    if (monthsAgo < 7) {
      return this.renderMonthsAgo(monthsAgo);
    }

    return this.renderInMonthYear(setFilterData);
  }
}

export default LastUpdated;
